export const SITESETUP_GET_SERVED_ITEMS = 'SITESETUP_GET_SERVED_ITEMS';
export const SITESETUP_GET_SERVED_ITEMS_ERROR =
  'SITESETUP_GET_SERVED_ITEMS_ERROR';
export const SITESETUP_GET_SERVED_ITEMS_NUTRITION =
  'SITESETUP_GET_SERVED_ITEMS_NUTRITION';
export const SITESETUP_GET_SERVED_ITEMS_NUTRITION_ERROR =
  'SITESETUP_GET_SERVED_ITEMS_NUTRITION_ERROR';
export const SITESETUP_SERVED_ITEMS_NUTRITION_FETCHING =
  'SITESETUP_SERVED_ITEMS_NUTRITION_FETCHING';



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/servedItems/types.js